export default defineNuxtPlugin(() => {
  const criticalPages = [
    '/orders',
    '/new-order',
    '/settings',
  ]

  if (import.meta.client) {
    const preloadPages = async () => {
      await new Promise(resolve => setTimeout(resolve, 2000))

      for (const path of criticalPages) {
        try {
          await preloadRouteComponents(path)
          console.log('[Preload] Prefetched:', path)
        } catch (err) {
          console.warn('[Preload] Failed to prefetch:', path, err)
        }
      }
    }

    if (document.readyState === 'complete') {
      preloadPages()
    } else {
      window.addEventListener('load', preloadPages)
    }
  }
})
